<script setup>
import { ref } from 'vue'
import Vapor from 'laravel-vapor'
import Button from '@components/global/forms/Button.vue'
import { useGlobalStore } from '@stores/global'
import { useSubmissionStore } from '@stores/submission'

const global = useGlobalStore()
const submission = useSubmissionStore()
const file = ref(null)

const upload = () => {
	if (!submission.fileUploading) {
		submission.fileUploading = true
		Vapor.store(file.value.files[0], {
			visibility: 'public-read',
		})
			.then((response) => {
				submission.form.order_file = {
					uuid: response.uuid,
					key: response.key,
					extension: response.extension,
				}
				submission.fileUploading = false
				global.closeModal()
			})
			.catch((error) => {
				console.error('Upload Failed', error.response.data)
				submission.fileUploading = false
			})
	}
}
</script>

<template>
	<Button class="mt-5 !w-full" iconLeft="fas fa-upload" @click="file.click()" :uploading="submission.fileUploading">Upload Screenshot</Button>
	<input class="hidden" type="file" id="file" ref="file" accept=".jpg, .jpeg, .png" @change="upload" />
	<!-- <div class="flex items-center gap-2 text-xs text-fury-red-500" v-if="error">
		<i class="far fa-triangle-exclamation" />
		<span>{{ error }}</span>
	</div> -->
</template>
